module.exports = __webpack_public_path__ + "img/songfile-landing-headphones.a42262f4.png";